import React from 'react'
import SearchNews from '../../components/SearchNews'
import { t } from 'i18next'
import CustomImageComponent from '../../components/CustomImageComponent'
import { useCountryPrefix } from '../../routes/useCountryPrefix'
import { useTranslation } from 'react-i18next'

const NewsSec = (props) => {
    const countryPrefix = useCountryPrefix();
    const { i18n } = useTranslation();
    const currentLang = i18n.language === "en" ? "" : i18n.language || "";

    const { data, onLoadMore, loadingMore = false } = props

    return (
        <>
            <section className="details-slider-section mt-5">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 left-content ">
                            <div className="news-section news-page">
                                {data?.items?.length &&
                                    data.items?.map((item, index) => (
                                        <div className="flex-card mb-5" key={index}>
                                            <div className="img-block">
                                                <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/blogs/${item.slug}`}>
                                                    <CustomImageComponent
                                                        src={item.blogThumbnail}
                                                        alt={item.blogCategoryName}
                                                        className={"img-fluid news-img"}
                                                    />
                                                </a>
                                                <span className="date-text">
                                                    {new Date(item.publishedDate).toLocaleString("default", {
                                                        month: "long",
                                                    }) +
                                                        " " +
                                                        new Date(item.publishedDate).getDate() +
                                                        ", " +
                                                        new Date(item.publishedDate).getFullYear()}
                                                </span>
                                            </div>
                                            <div className="content-block">
                                                <ul className="category-list">
                                                    <li className="active">
                                                        <span><CustomImageComponent src={"/assets/img/admin-icon.svg"} alt={item.author} className={"img-fluid"} /> {item.author}</span>
                                                    </li>

                                                </ul>
                                                <h3>
                                                    <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/blogs/${item.slug}`} className="link">
                                                        <span className="underline">
                                                            {item.title}
                                                        </span>
                                                    </a>
                                                </h3>
                                                <a href={`/${countryPrefix}${currentLang ? `/${currentLang}` : ""}/blogs/${item.slug}`} className="text-black">
                                                    <div dangerouslySetInnerHTML={{ __html: `${item.content.substring(0, 280)}...` }} /></a>

                                            </div>
                                        </div>
                                    ))}

                                {/* Load More Button */}
                                {data.pageIndex < data.totalPages && (
                                    <div className="text-center mt-4 mb-4">
                                        <button className="theme-btn theme-btn-secondary" onClick={onLoadMore} disabled={loadingMore}>
                                            {loadingMore ? (<i className="fa fa-spinner fa-spin fa-2x ms-0"></i>) : (t("load_more"))}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                        <div className="col-md-4 right-content">

                            <SearchNews data={data}></SearchNews>
                        </div>
                    </div>
                </div>

            </section>

        </>
    )
}

export default NewsSec